import { Coin } from './../../models/Coin';
import { Component, Input } from '@angular/core';
import { CoinsProvider } from '../../providers/coins/coins';

@Component({
  selector: 'coin-chart-simple-dynamic',
  templateUrl: 'coin-chart-simple-dynamic.html'
})
export class CoinChartSimpleDynamicComponent {

  @Input('width') width: number;
  @Input('height') height: number;
  @Input('coin') coin: Coin;
  @Input('data') data: any[];


  view: any[] = [200, 200];

  // options
  showXAxis = false;
  showYAxis = true;
  gradient = false;
  showLegend = false;
  showXAxisLabel = false;
  xAxisLabel = 'Time';
  showYAxisLabel = false;
  yAxisLabel = 'Price';
  tooltipDisabled = false;
  colorScheme = {
    domain: ['#ffffff']
  };

  autoScale = true;

  constructor(private CP: CoinsProvider) {

  }

  ngOnInit(){
    this.view = [this.width, this.height];
  }

}



// WEBPACK FOOTER //
// ./src/components/coin-chart-simple-dynamic/coin-chart-simple-dynamic.ts